import { MODAL } from '../../../redux/types';
import { useDispatch } from 'react-redux';
import { useInternationalization } from '@progress/kendo-react-intl';

import { IBoardMeasure } from '../types/IBoardMeasure';
import { IHomeContent } from '../types/IHomeContent';
import { ICurrency } from '../types/ICurrency';
import { ICashflow } from '../types/ICashflow';

const useWidgetUtils = (type: string, measures: IBoardMeasure[], objectValueMap: Map<number, any> | null, homeContent?: IHomeContent) => {
  const dispatch = useDispatch();
  const intl = useInternationalization();

  const _idAndTypeFromField = (fieldName: string): any => {
    let split = (type === 'treelist' ? fieldName : fieldName.slice(8)).split('_');

    if (split.length < 2) return null;

    return {
      id: parseInt(split[1]),
      type: split[0],
      nodeId: split.length === 3 ? split[2] : null,
    };
  };

  const _replaceRowAmount = (field: string): string => {
    return field.replace(/_rowAmount$/, '');
  }

  const _getCashflowInfo = (dataItem: any, fieldName: string, singlePeriod: boolean): ICashflow | undefined => {
    fieldName = _replaceRowAmount(fieldName);

    let idAndType = _idAndTypeFromField(fieldName);
    if (!idAndType) return;

    let measure = measures.find((m) => m.id === idAndType.id);

    if (measure && measure.id) {
      let objectVal = objectValueMap?.get(dataItem[type === 'treelist' ? 'nodeId' : singlePeriod ? 'objectId' : 'periodId']);
      let key = singlePeriod ? measure.id.toString() : `${measure.id}_${idAndType.nodeId}`;
      return {
        nodeId: objectVal.map[key || ''].nodeId,
        valueId: objectVal.map[key || ''].valueId,
        valueInfo: {
          name: dataItem.name,
          measure: measure,
          amount: dataItem[fieldName] || 0,
        },
      };
    } else return;
  };

  const openCashflowDialog = (dataItem: any, field: string, columnName: string, boardId: string, investorId: string, treelist: boolean, singlePeriod: boolean, localCurrency?: ICurrency) => {
    let item = dataItem[field];
    let cashFlowInfo = _getCashflowInfo(dataItem, field, singlePeriod);

    dispatch({
      type: MODAL.SWITCH_CASH_FLOW_MODAL,
      payload: {
        dataItem: dataItem,
        cashFlowInfo: cashFlowInfo,
        investorObjectId: investorId,
        columnName: columnName,
        value: intl.toString(item.rowAmount, (item.isPercent ? 'p' : 'n') + item.scale),
        boardId: boardId,
        selectedCurrency: localCurrency,
      },
    });
  };

  return { openCashflowDialog };
};

export default useWidgetUtils;
